import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as api from '../api/externalSystemServices';
import * as actions from '../actions/externalSystemActions'

function* getExternalSystemDatas(payload) {
    try {
        yield put(actions.getExternalSystemDatasRequestStatus(true));
        const result = yield call(api.getExternalSystemDatas, payload);
        yield put(actions.getExternalSystemDatasRequestStatus(false));

        let response = {};

        if (result?.data !== '') {
            response = {
                data: result.data,
                errorDetails: null
            };
        }

        else {
            response = {
                data: result.data,
                errorDetails: {
                    responseType: 'warning',
                    responseDsc: 'lblNoResultFound'
                }
            };
        }

        yield put(actions.getExternalSystemDatasRequestSuccess(response));

        return response;
    }
    catch (error) {
        yield put(actions.getExternalSystemDatasRequestStatus(false));
        console.log(error);
    }
}


function* watchGetExternalSystemDatas() {
    yield takeEvery(actions.Types.GET_EXTERNAL_SYSTEM_DATAS_REQUEST, getExternalSystemDatas);
}

const defectExternalSystem = [fork(watchGetExternalSystemDatas)];

export default defectExternalSystem;